import { TOKEN_KEY } from "./auth.service";

function getPermissionById(id: string, permissions: Array<string>): string {
  for (let i = 0; i < permissions.length; i++) {
    const item = splitPermission(permissions[i]);
    if (item[0] === id) return item[1];
  }
  return null;
}

function splitPermission(value: string): string[] {
  if (!value) return null;

  return value.split("_");
}

export function hasPerm(perm: Permission): boolean {
  const permissions = getPermissions();
  const checkPermission = splitPermission(perm);
  if (!checkPermission || !permissions || permissions.length < 1) return false;

  const permById = getPermissionById(checkPermission[0], permissions);
  return permById !== null && permById?.includes(checkPermission[1]);
}

export function getPermissions(): Array<string> {
  try {
    const token = JSON.parse(sessionStorage.getItem(TOKEN_KEY));
    if (!token?.access_token) return [];
    const accessToken = token.access_token.split(".")[1];
    const access = JSON.parse(atob(accessToken));
    return access?.authorities ?? [];
  } catch {
    return [];
  }
}

export function getPermissionCode(p: Permission): number {
  return Number(splitPermission(p)[0]);
}

export enum Permission {
  AGENDAMENTO_PROPRIO_CREATE = "126_C",
  AGENDAMENTO_PROPRIO_READ = "126_R",
  AGENDAMENTO_PROPRIO_UPDATE = "126_U",
  AGENDAMENTO_PROPRIO_DELETE = "126_D",

  AGENDAMENTO_TERCEIRO_CREATE = "128_C",
  AGENDAMENTO_TERCEIRO_READ = "128_R",
  AGENDAMENTO_TERCEIRO_UPDATE = "128_U",
  AGENDAMENTO_TERCEIRO_DELETE = "128_D",

  AGENDAMENTO_MEDIACAO_CREATE = "129_C",
  AGENDAMENTO_MEDIACAO_READ = "129_R",
  AGENDAMENTO_MEDIACAO_UPDATE = "129_U",
  AGENDAMENTO_MEDIACAO_DELETE = "129_D",

  AREA_COMUM_CREATE = "109_C",
  AREA_COMUM_READ = "109_R",
  AREA_COMUM_UPDATE = "109_U",

  CAMERA_READ = "113_R",

  CATEGORIA_CHAMADO_READ = "123_R",

  CHAVE_READ = "119_R",

  CHAMADO_READ = "122_R",
  CHAMADO_UPDATE = "122_U",

  CONFIGURACOES_CREATE = "100_C",
  CONFIGURACOES_READ = "100_R",
  CONFIGURACOES_UPDATE = "100_U",

  CONFIGURAR_CAMERA_CREATE = "101_C",
  CONFIGURAR_CAMERA_READ = "101_R",
  CONFIGURAR_CAMERA_UPDATE = "101_U",

  CONFIGURAR_PSIM_CREATE = "103_C",
  CONFIGURAR_PSIM_READ = "103_R",
  CONFIGURAR_PSIM_UPDATE = "103_U",

  CONTA_CREATE = "3_C",
  CONTA_READ = "3_R",

  CORRESPONDENCIA_CREATE = "120_C",
  CORRESPONDENCIA_READ = "120_R",

  DOCUMENTO_CREATE = "132_C",
  DOCUMENTO_READ = "132_R",
  DOCUMENTO_UPDATE = "132_U",
  DOCUMENTO_DELETE = "132_D",

  DISPOSITIVO_READ = "117_R",

  ESTACIONAMENTO_READ = "111_R",
  ESTACIONAMENTO_UPDATE = "111_U",
  ESTACIONAMENTO_DELETE = "111_D",

  EVENTO_CREATE = "114_C",
  EVENTO_READ = "114_R",

  GRUPO_READ = "105_R",

  INTEGRADOR_READ = "2_R",
  INTEGRADOR_CREATE = "2_C",
  INTEGRADOR_UPDATE = "2_U",

  PESSOA_CREATE = "106_C",
  PESSOA_READ = "106_R",
  PESSOA_UPDATE = "106_U",
  PESSOA_DELETE = "106_D",

  PORTARIA_READ = "124_R",
  PORTARIA_CREATE = "124_C",

  PREVISAO_VISITA_READ = "125_R",
  PREVISAO_VISITA_CREATE = "125_C",

  RECADO_CREATE = "121_C",
  RECADO_READ = "121_R",
  RECADO_UPDATE = "121_U",
  RECADO_DELETE = "121_D",

  UNIDADE_READ = "110_R",
  UNIDADE_UPDATE = "110_U",
  UNIDADE_DELETE = "110_D",
  MEUS_DADOS_DELETE = "127_D",
  MEUS_DADOS_UPDATE = "127_U",
  MEUS_DADOS_CREATE = "127_C",
  MEUS_DADOS_READ = "127_R",

  RELATORIO_PRIMEIRO_ACESSO_CREATE = "130_C",
  RELATORIO_REGISTRO_CHAMADA = "131_C",
  RELATORIO_ABERTURA_PORTA = "133_C",
  RELATORIO_UNIDADE = "134_C",
  RELATORIO_VEICULO_READ = "140_R",

  ENQUETE_CREATE = "135_C",
  ENQUETE_READ = "135_R",
  ENQUETE_UPDATE = "135_U",
  ENQUETE_DELETE = "135_D",

  ASSEMBLEIA_CREATE = "136_C",
  ASSEMBLEIA_READ = "136_R",
  ASSEMBLEIA_UPDATE = "136_U",
  ASSEMBLEIA_DELETE = "136_D",

  MANUTENCAO_PREVENTIVA_CREATE = "137_C",
  MANUTENCAO_PREVENTIVA_READ = "137_R",
  MANUTENCAO_PREVENTIVA_UPDATE = "137_U",
  MANUTENCAO_PREVENTIVA_DELETE = "137_D",

  RELATORIO_MANUTENCAO_PREVENTIVA_CREATE = "139_C",

  FORNECEDORES_CREATE = "138_C",
  FORNECEDORES_READ = "138_R",
  FORNECEDORES_UPDATE = "138_U",
  FORNECEDORES_DELETE = "138_D",

  ENTREGA_AUTONOMA_CREATE = "141_C",
  ENTREGA_AUTONOMA_READ = "141_R",
  ENTREGA_AUTONOMA_UPDATE = "141_U",
  ENTREGA_AUTONOMA_DELETE = "141_D",

  INQUILINO_CREATE = "142_C",
  INQUILINO_READ = "142_R",
  INQUILINO_UPDATE = "142_U",
  INQUILINO_DELETE = "142_D",

  SHIELD_READ = '143_R',

  INTEGRADOR_RECADO_CREATE = "144_C",
  INTEGRADOR_RECADO_READ = "144_R",
  INTEGRADOR_RECADO_UPDATE = "144_U",
  INTEGRADOR_RECADO_DELETE = "144_D",

  ZELADOR_IA_CREATE = "141843_C",
  ZELADOR_IA_READ = "141843_R",
  ZELADOR_IA_UPDATE = "141843_U",
  ZELADOR_IA_DELETE = "141843_D",
  CONVITE_VIRTUAL_CREATE = "310921_C",
  CONVITE_VIRTUAL_READ = "310921_R",
  CONVITE_VIRTUAL_UPDATE = "310921_U",
  CONVITE_VIRTUAL_DELETE = "310921_D",
  CHAVE_VIRTUAL_CREATE = "311048_C",
  CHAVE_VIRTUAL_READ = "311048_R",
  CHAVE_VIRTUAL_UPDATE = "311048_U",
  CHAVE_VIRTUAL_DELETE = "311048_D",

  EQUIPAMENTO_PAC_CREATE = "161108_C",
  EQUIPAMENTO_PAC_READ = "161108_R",
  EQUIPAMENTO_PAC_UPDATE = "161108_U",
  EQUIPAMENTO_PAC_DELETE = "161108_D",
}
